import {Autocomplete} from "@mui/material";
import {TextField} from "@variocube/app-ui";
import React, {ReactNode} from "react";
import {useAsync} from "react-async-hook";
import {useInvoicesApi} from "../api";
import {useLocalization} from "../i18n";

// Keep in sync with OrderNumber.isAuftragsnummer in the backend
const PROFIT_CENTER_PATTERN = /^([0-9]{12}|[a-zA-Z0-9]{11}|[a-zA-Z]{2}[a-zA-Z0-9]{1,8})$/;

interface ProfitCenterFieldProps {
	label?: ReactNode;
	value: string | undefined;
	onChange: (value: string | undefined) => any;
	required?: boolean;
	fullWidth?: boolean;
}

export function ProfitCenterField({label, value, onChange, required, fullWidth}: Readonly<ProfitCenterFieldProps>) {
	const {t} = useLocalization();
	const {listProfitCenterHistory} = useInvoicesApi();

	const {loading, result: history} = useAsync(listProfitCenterHistory, []);

	const format = t("invoices.details.profitCenterFormat");

	return (
		<Autocomplete
			loading={loading}
			options={history ?? []}
			renderInput={(parameters) => (
				<TextField
					required={required}
					label={label}
					{...parameters}
					value={value}
					helperText={format}
					validate={value => value && !PROFIT_CENTER_PATTERN.test(value) ? format : undefined}
					InputProps={{
						...parameters.InputProps,
						value: value,
					}}
					InputLabelProps={{
						shrink: Boolean(value) || undefined,
					}}
					inputProps={{
						...parameters.inputProps,
						value: value,
						pattern: PROFIT_CENTER_PATTERN.source,
						title: format,
					}}
				/>
			)}
			freeSolo
			autoSelect
			value={value}
			inputValue={value}
			onInputChange={(_, value) => onChange(value?.trim())}
			fullWidth={fullWidth}
		/>
	);
}
